
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/jiraIssueCollector/components/ScreenRecordingIndicator.scss.css.virtualfile';
        module.exports = {"top":"_top_e4mlu_1","bottom":"_bottom_e4mlu_2","left":"_left_e4mlu_3","right":"_right_e4mlu_4"};